<template>
  <div class="relative animated-image">
    <img
      v-for="(data, index) in currentImages"
      :key="index"
      :src="`/images/animated-products/${path}/${index + 1}.png`"
      :class="{
        'absolute top-0 left-0': index > 0,
      }"
      :style="{
        '--t-x': data.translate[0] || 0,
        '--t-y': data.translate[1] || 0,
        '--t-s': data.scale || 1,
      }"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps(["slug"]);

const path = computed(() => {
  switch (props.slug) {
    case "olives":
    case "elies":
      return "olives";
    case "fruits":
    case "froyta":
      return "fruits";
    case "spreads":
      return "spreads";
    default:
      return "";
  }
});
const count = computed(() => {
  switch (path.value) {
    case "olives":
      return 5;
    case "fruits":
      return 5;
    case "spreads":
      return 8;
  }
});

const images = {
  olives: [
    { translate: [1.1, -1], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [0, 0], scale: 1.1 },
  ],
  fruits: [
    { translate: [1.1, -1], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [0, 0], scale: 1.2 },
  ],
  spreads: [
    { translate: [1.1, -1], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [0, 0], scale: 1.2 },
    { translate: [1.1, -1], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [0, 0], scale: 1.2 },
    { translate: [1.1, -1], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [-1, 1.1], scale: 1.1 },
    { translate: [-0.9, -1], scale: 1.1 },
    { translate: [1.1, 0.9], scale: 1.1 },
    { translate: [0, 0], scale: 1.2 },
  ],
};

const currentImages = computed(() => {
  return images[path.value] || [];
});
</script>

<style scoped lang="scss">
.animated-image {
  --t-x: 0;
  --t-y: 0;
  --t-s: 1;
  img {
    //transition: transform 0.6s ease-out;
    transition: transform 1.2s cubic-bezier(0.76, 0.24, 0.32, 1.16);
    perspective: 50px;
    will-change: transform;
    //--pos-x: calc(var(--t-x) * 1%);
    //--pos-y: calc(var(--t-y) * 1%);
    //
    //transform: translate3d(var(--pox-x), var(--pos-y), 0) scale(var(--t-s));
  }

  &:hover {
    img {
      --pos-x: calc(var(--t-x) * 1%);
      --pos-y: calc(var(--t-y) * 1%);

      transform: translate3d(var(--pos-x), var(--pos-y), 10px) scale(var(--t-s)) rotateY(5deg);
      //opacity: 0.2;
    }
  }
}
</style>
